import {
  UploadFile,
  UploadFileMultiple,
  CommonTabs,
  PreviewFileModal,
  GoodsTemplate,
  queryDateSearch,
  ChooseRadioGoods,
  ChooseRadioShops,
  OrgQueryTree,
  ChooseShopSelect,
  DayMonthsYear,
  ChooseSceneSelect,
  ColumnConfigBtn,
  ChooseCategorySelect,
  ChooseGenerateSelect,
  ChooseCheckboxGoods,
  Range,
  ChooseOrgBtn,
  ChooseShopBtn,
  ChooseSceneTable,
  SelectGoodsBrand,
  ChooseMctUser,
  ChooseUserSelect,
  SwitchLanguage,
  ChooseOperatorSelect
} from './index'

function install(Vue) {
  Vue.component('upload-file', UploadFile)
  Vue.component('upload-file-multiple', UploadFileMultiple)
  Vue.component('common-tabs', CommonTabs)
  Vue.component('goods-template', GoodsTemplate)
  Vue.component('preview-file-modal', PreviewFileModal)
  Vue.component('query-date-search', queryDateSearch)
  Vue.component('choose-radio-goods', ChooseRadioGoods)
  Vue.component('choose-radio-shops', ChooseRadioShops)
  Vue.component('org-query-tree', OrgQueryTree)
  Vue.component('choose-shop-select', ChooseShopSelect)
  Vue.component('day-months-year', DayMonthsYear)
  Vue.component('choose-scene-select', ChooseSceneSelect)
  Vue.component('column-config-btn', ColumnConfigBtn)
  Vue.component('choose-category-select', ChooseCategorySelect)
  Vue.component('choose-generate-select', ChooseGenerateSelect)
  Vue.component('choose-checkbox-goods', ChooseCheckboxGoods)
  Vue.component('range', Range)
  Vue.component('choose-org-btn', ChooseOrgBtn)
  Vue.component('choose-shop-btn', ChooseShopBtn)
  Vue.component('choose-scene-table', ChooseSceneTable)
  Vue.component('select-goods-brand', SelectGoodsBrand)
  Vue.component('choose-mct-user', ChooseMctUser)
  Vue.component('choose-user-select', ChooseUserSelect)
  Vue.component('switch-language', SwitchLanguage)
  Vue.component('choose-operator-select', ChooseOperatorSelect)
}

export default install
